import sessionConstants from "csi/sessionConstants";
import { LOCATION_SECTION, LOCATION_SECTION_ITEM, LOCATION_TAB, LOCATION_TYPE } from "../utility/routerUtility";
declare global {
	interface Window {
		dataLayer?: any;
	}
}

const DEFAULT_PAGE_TITLE = "Centric > TitleNotSet";

/**
 * Generate the custom dimention title based on the input URL
 * @param {string} url 
 * @return {string}
 */
const generateCustomDimensionTitle = (url: string): string => {
	const urlParams = new URLSearchParams(url);
	const type = urlParams.get(LOCATION_TYPE);
	const tab = urlParams.get(LOCATION_TAB);
	const section = urlParams.get(LOCATION_SECTION );
	const sectionItem = urlParams.get(LOCATION_SECTION_ITEM );
	const tabTitleStr = tab ? ` > ${tab}` : "";
	const title = section ? `${type} > ${section} > ${sectionItem}${tabTitleStr}` : `${type}${tabTitleStr}`;

	return title;
};

/**
 * Push URL data to google tag manager
 */
export function pushUrlDataToGtm(): void {
	if (window.dataLayer) {
		// google tag manager is loaded 
		const pageUrl = window.location.href;
		let pageTitle = generateCustomDimensionTitle(pageUrl);

		if (!pageTitle) {
			// set page title to default if URL doesn't have needed parameters to build the page title
			pageTitle = DEFAULT_PAGE_TITLE;
		}

		window.dataLayer.push({
			event: "virtualPageview",
			pageUrl,
			pageTitle,
		});
	}
}

/**
 * load and initialize the google tag manager
 */
export function init(): void {
	if (!sessionConstants.gtmId) {
		return;
	}

	// Begin boilerplate code
	(function(w, d, s, l, i): void {
		w[l]=w[l]||[];w[l].push({ "gtm.start": new Date().getTime(), event:"gtm.js" });
		var f=d.getElementsByTagName(s)[0], j=<HTMLScriptElement>d.createElement(s), dl=l!="dataLayer"?"&l="+l:"";
		j.async=true;
		j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j, f);
	})(window, document, "script", "dataLayer", sessionConstants.gtmId);
	// End boilerplate code
}